import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Typography } from "@parkschannel/ui";
export const FooterList = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx("ul", {
        className: "grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-1",
        children: children
    });
};
export const FooterListEl = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx("li", {
        className: "w-full ",
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "bodyLarge",
            className: "text-neutral-800 font-medium lg:hover:underline md:!text-sm",
            children: children
        })
    });
};
